import { Injectable } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import * as activeLanguagesActions from "../actions/active-languages.action";

import * as fromRoot from "#core/router-store";
import { SchoolsService } from "@carnegie-learning/data-access-angular-passport";
import { Store } from "@ngrx/store";

@Injectable()
export class ActiveLanguagesEffects {
    constructor(
        private actions$: Actions,
        private schoolsService: SchoolsService,
        private store: Store<fromRoot.CustomSerializer>
    ) {}

    loadActiveLanguages$ = createEffect(() =>
        this.actions$
            .pipe(ofType(activeLanguagesActions.loadActiveLanguages))
            .pipe(
                map((action) => action.payload),
                switchMap((payload) => {
                    return this.schoolsService.getActivePrograms(payload).pipe(
                        map((activeLanguages) =>
                            activeLanguagesActions.loadActiveLanguagesSuccess({
                                payload: activeLanguages,
                            })
                        ),
                        catchError((error) =>
                            of(
                                activeLanguagesActions.loadActiveLanguagesFail({
                                    payload: error,
                                })
                            )
                        )
                    );
                })
            )
    );
}
